<template>
  <div class="footer-cta-wrapper">
    <section class="cta-bottom">
      <div class="container">
        <h2 class="title">Want to join our talent network?</h2>
        <p class="subtitle">
          Build a career you're proud of with the power of Proxify.
        </p>
        <ApplyButton
          cta-section="footer"
          :page-name="pageName"
          class="proxify-btn proxify-btn-white"
        />
      </div>
    </section>
    <footer class="footer">
      <div class="container">
        <ul class="navigation">
          <li>
            <nuxt-link
              to="/"
              class="logo"
              aria-label="Proxify homepage"
            >
              <LogoIcon color="white" />
            </nuxt-link>
          </li>
          <li class="navigation-list">
            <ul class="navigation-links">
              <li>
                <div class="title">Navigation</div>
                <nuxt-link
                  to="/how-it-works"
                  aria-label="How it works"
                  exact
                >
                  How it works
                </nuxt-link>
                <nuxt-link
                  to="/journal"
                  exact
                  aria-label="The journal"
                >
                  The journal
                </nuxt-link>
                <nuxt-link
                  to="/events"
                  exact
                  aria-label="Events"
                >
                  Events
                </nuxt-link>
                <nuxt-link
                  to="/jobs"
                  exact
                  aria-label="Jobs"
                >
                  Jobs
                </nuxt-link>
              </li>
              <li>
                <div class="title">Legal</div>
                <nuxt-link
                  to="/privacy"
                  aria-label="Privacy Policy"
                >
                  Privacy Policy
                </nuxt-link>
                <nuxt-link
                  to="/cookie-policy"
                  aria-label="Cookie Policy"
                >
                  Cookie Policy
                </nuxt-link>
                <nuxt-link
                  to="/accessibility-statement"
                  aria-label="Accessibility Statement"
                >
                  Accessibility Statement
                </nuxt-link>
              </li>
              <li class="contact-li">
                <div class="title">Contact</div>
                <a href="mailto:work@proxify.io">work@proxify.io</a>
                <div class="address">
                  <p>
                    Barnhusgatan 3
                    <br />
                    111 23 Stockholm
                    <br />
                    SWEDEN
                  </p>
                </div>
              </li>
              <li>
                <div class="title">Follow us</div>
                <div class="social">
                  <a
                    href="https://www.linkedin.com/showcase/proxify-developers/"
                    target="_blank"
                    rel="noopener"
                    aria-label="linkedin link"
                  >
                    <LinkedInCircleIcon />
                  </a>
                  <a
                    href="https://www.facebook.com/Proxify.Developers"
                    target="_blank"
                    rel="noopener"
                    aria-label="facebook link"
                  >
                    <FacebookCircleIcon />
                  </a>
                  <a
                    href="https://www.instagram.com/proxify.developers"
                    target="_blank"
                    rel="noopener"
                    aria-label="instagram link"
                  >
                    <InstagramCircleIcon />
                  </a>
                  <a
                    href="https://twitter.com/Proxify_Dev"
                    target="_blank"
                    rel="noopener"
                    aria-label="twitter link"
                  >
                    <XIcon />
                  </a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';
import InstagramCircleIcon from '~/components/Common/Svg/InstagramCircleIcon.vue';
import FacebookCircleIcon from '~/components/Common/Svg/FacebookCircleIcon.vue';
import LinkedInCircleIcon from '~/components/Common/Svg/LinkedInCircleIcon.vue';
import LogoIcon from '~/components/Common/Svg/LogoIcon.vue';
import XIcon from '~/components/Common/Svg/Social/XIcon.vue';
import slugRouteName from '~/mixins/slugRouteName';

export default {
  name: 'AppFooter',
  components: {
    ApplyButton,
    LogoIcon,
    LinkedInCircleIcon,
    InstagramCircleIcon,
    FacebookCircleIcon,
    XIcon,
  },
  mixins: [slugRouteName],
};
</script>

<style lang="scss" scoped>
@import './CtaBottom.scss';
@import './AppFooter.scss';
</style>
